import { apiRequest } from 'api/apiClient';
import superUserRequest from 'utils/superUserRequest';

const impersonateUser = async (userUid) =>
  superUserRequest('POST', `/v1/users/impersonate/${userUid}`);

const exitImpersonation = async () => apiRequest('POST', '/v1/users/exit-impersonation');

const USERS_MUTATIONS = {
  IMPERSONATE_USER: impersonateUser,
  EXIT_IMPERSONATION: exitImpersonation,
};

export default USERS_MUTATIONS;
